function cmShadeMatchesEyeFilter($el, filter) {
  if (filter === "all") {
    return true;
  }
  var categories = ($el.attr("data-eye") || "").split(" ");
  return categories.indexOf(filter) !== -1;
}

function cmHandleEyeFilterClick($pill, $pills, $swatches, $shadeSelectOptions) {
  $pills.removeClass("active");
  $pill.addClass("active");

  var filter = $pill.attr("data-eye-filter");
  var $firstVisible = null;

  $swatches.each(function () {
    var $swatch = $(this);
    var show = cmShadeMatchesEyeFilter($swatch, filter);
    $swatch.css("display", show ? "" : "none");
    if (show && !$firstVisible) {
      $firstVisible = $swatch;
    }
  });

  $shadeSelectOptions.each(function () {
    var $option = $(this);
    $option.css("display", cmShadeMatchesEyeFilter($option, filter) ? "" : "none");
  });

  if ($firstVisible) {
    $firstVisible.trigger("click");
  }
}

function cmSyncShadeSelect($swatch, $group, $matchText, $matchLabel, $shadeSelect, $shadeSelectToggle, $shadeSelectOptions) {
  if ($matchText.length && $matchLabel.length) {
    var label = $swatch.attr("data-eye-label");
    if (label) {
      $matchLabel.text(label);
      $matchText.show();
    } else {
      $matchText.hide();
    }
  }

  if ($shadeSelectToggle.length) {
    var $matchingOption = $group.find(
      '[data-shade-select-option][data-id="' + $swatch.attr("data-id") + '"]',
    );

    if ($matchingOption.length) {
      $shadeSelectToggle
        .find(".simple-product_shade-select-thumb")
        .html($matchingOption.find(".simple-product_shade-select-thumb").html());
      $shadeSelectToggle
        .find(".simple-product_shade-select-label")
        .html($matchingOption.find(".simple-product_shade-select-label").html());

      $shadeSelectOptions.removeClass("active");
      $matchingOption.addClass("active");
    }
  }

  if ($shadeSelect.length) {
    $shadeSelect.removeClass("open");
  }
}

function cmHandleShadeSelectOptionClick($option, $group, $pills, $swatches) {
  var variantId = $option.attr("data-id");
  var $matchingSwatch = $group.find(
    '.simple-product-shades_grid .simple-product_shade[data-id="' + variantId + '"]',
  );

  if (!$matchingSwatch.length) {
    return;
  }

  if ($matchingSwatch.css("display") === "none") {
    $pills.removeClass("active");
    $group.find('.simple-product_eye-filter-pill[data-eye-filter="all"]').addClass("active");
    $swatches.css("display", "");
  }

  $matchingSwatch.trigger("click");
}

function cmInitShadeEyeFilter($group) {
  var $pills = $group.find(".simple-product_eye-filter-pill");
  var $swatches = $group.find(".simple-product-shades_grid .simple-product_shade");
  var $matchText = $group.find(".simple-product_eye-match-text");
  var $matchLabel = $group.find("[data-eye-match-label]");
  var $shadeSelect = $group.find("[data-shade-select]");
  var $shadeSelectToggle = $group.find("[data-shade-select-toggle]");
  var $shadeSelectOptions = $group.find("[data-shade-select-option]");

  $pills.on("click", function () {
    cmHandleEyeFilterClick($(this), $pills, $swatches, $shadeSelectOptions);
  });

  $swatches.on("click", function () {
    cmSyncShadeSelect(
      $(this),
      $group,
      $matchText,
      $matchLabel,
      $shadeSelect,
      $shadeSelectToggle,
      $shadeSelectOptions,
    );
  });

  $shadeSelectToggle.on("click", function () {
    $shadeSelect.toggleClass("open");
  });

  $shadeSelectOptions.on("click", function () {
    cmHandleShadeSelectOptionClick($(this), $group, $pills, $swatches);
  });

  $(document).on("click", function (event) {
    if ($shadeSelect.length && !$shadeSelect.is(event.target) && !$shadeSelect.has(event.target).length) {
      $shadeSelect.removeClass("open");
    }
  });
}

function cmInitAllShadeEyeFilters() {
  $(".ts-product__block").each(function () {
    var $group = $(this);
    if ($group.find("[data-shade-select]").length) {
      cmInitShadeEyeFilter($group);
    }
  });
}

function cmUpdateUgcArrows($carousel, $prev, $next) {
  var el = $carousel[0];
  var maxScrollLeft = el.scrollWidth - el.clientWidth;

  $prev.toggleClass("is-hidden", el.scrollLeft <= 1);
  $next.toggleClass("is-hidden", el.scrollLeft >= maxScrollLeft - 1);
}

function cmScrollUgcCarousel($carousel, direction) {
  var el = $carousel[0];
  var $item = $carousel.find(".simple-product_ugc-item").first();
  if (!$item.length) return;

  var itemWidth = $item[0].getBoundingClientRect().width;
  var gap = parseFloat($carousel.css("gap")) || 0;

  el.scrollBy({ left: direction * (itemWidth + gap), behavior: "smooth" });
}

function cmInitUgcCarousel($carousel) {
  var $wrap = $carousel.closest(".simple-product_ugc-carousel-wrap");
  var $prev = $wrap.find("[data-ugc-prev]");
  var $next = $wrap.find("[data-ugc-next]");

  cmUpdateUgcArrows($carousel, $prev, $next);

  $carousel.on("scroll", function () {
    cmUpdateUgcArrows($carousel, $prev, $next);
  });

  $(window).on("resize", function () {
    cmUpdateUgcArrows($carousel, $prev, $next);
  });

  $prev.on("click", function () {
    cmScrollUgcCarousel($carousel, -1);
  });

  $next.on("click", function () {
    cmScrollUgcCarousel($carousel, 1);
  });
}

function cmInitAllUgcCarousels() {
  $("[data-ugc-carousel]").each(function () {
    cmInitUgcCarousel($(this));
  });
}

function cmHandleAccordionTriggerClick($trigger) {
  var $item = $trigger.closest("[data-pv-accordion-item]");
  var $allItems = $item.closest(".ts-product__info").find("[data-pv-accordion-item]");
  var isOpen = $item.hasClass("is-open");

  $allItems.removeClass("is-open");

  if (!isOpen) {
    $item.addClass("is-open");
  }
}

function cmInitAccordion() {
  $("[data-pv-accordion-trigger]").on("click", function () {
    cmHandleAccordionTriggerClick($(this));
  });
}

function cmSelectUpsellSwatch($swatch) {
  var $card = $swatch.closest("[data-upsell-card]");
  var $swatches = $card.find("[data-upsell-swatch]");
  var $btn = $card.find("[data-upsell-btn]");
  var $label = $btn.find("[data-upsell-btn-label]");
  var $variantLabel = $card.find("[data-upsell-variant-label]");

  $swatches.removeClass("active");
  $swatch.addClass("active");

  $btn.attr("data-id", $swatch.attr("data-variant-id"));
  $btn.addClass("has-selection");

  if ($variantLabel.length) {
    $variantLabel.text($swatch.attr("data-shade-name"));
  }

  $btn.attr("data-confirmed", "true");
  $label.text("ADD TO CART");

  cmUpdateUpsellStickyBar();
}

function cmConfirmUpsellSelection($btn) {
  var $card = $btn.closest("[data-upsell-card]");
  var $swatches = $card.find("[data-upsell-swatch]");
  var $activeSwatch = $swatches.filter(".active").first();

  if (!$activeSwatch.length) {
    var $firstAvailable = $swatches.not(".is-unavailable").first();
    if ($firstAvailable.length) {
      cmSelectUpsellSwatch($firstAvailable);
    }
  }

  $btn.attr("data-confirmed", "true");
  $btn.addClass("has-selection");
  $btn.find("[data-upsell-btn-label]").text("ADD TO CART");
}

// BFCM visitors (cookie bfcm_visited): the upsell's BFCM % as _BFCMOFFER, or 0 for everyone else
function cmBfcmUpsellPercent($btn) {
  if (!/(?:^|; )bfcm_visited=true/.test(document.cookie)) return 0;
  return parseFloat($btn.attr("data-bfcm-discount")) || 0;
}

function cmAddUpsellToCart($btn) {
  $btn.addClass("adding");
  window._cartTimingStart = Date.now();
  window._cartTimingAction = "mpm_upsell_card";

  var $card = $btn.closest("[data-upsell-card]");
  var dataRealBundle = $card.find(".mpm_real-bundle-config").attr("data-real-bundle");

  var saleOfferPercent = parseFloat($btn.attr("data-sale-discount")) || 0;
  var saleOfferActive =
    saleOfferPercent > 0 &&
    typeof getSaleCollectionVisitedCookie === "function" &&
    getSaleCollectionVisitedCookie() === "true";
  var saleOfferProperties = saleOfferActive ? { _SALEOFFER: saleOfferPercent + "%" } : {};
  var bfcmPercent = cmBfcmUpsellPercent($btn);
  if (bfcmPercent > 0) saleOfferProperties = { _BFCMOFFER: bfcmPercent + "%" };

  var items = [];

  if (dataRealBundle === "true") {
    var bundleName = $btn.attr("data-bundle");
    $card.find(".mpm_real-bundle-config").each(function () {
      items.push({
        id: $(this).attr("data-id"),
        quantity: 1,
        properties: bfcmPercent > 0
          ? { Bundle: bundleName + " BFCM" }
          : Object.assign({ Bundle: bundleName }, saleOfferProperties),
      });
    });
  } else {
    items.push({
      id: $btn.attr("data-id"),
      quantity: 1,
      properties: saleOfferProperties,
    });
  }

  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: { items: items },
    dataType: "json",
    success: function (data) {
      $btn.removeClass("adding");
      if (window.refreshCartDrawer) window.refreshCartDrawer(false, data.sections);
      if (window.openCartDrawer) window.openCartDrawer(true);
    },
    error: function () {
      $btn.removeClass("adding");
      if (window.refreshCartDrawer) window.refreshCartDrawer(false, null);
      if (window.openCartDrawer) window.openCartDrawer(true);
    },
  });
}

function cmHandleUpsellBtnClick($btn) {
  var needsShade = $btn.attr("data-needs-shade") === "true";
  var confirmed = $btn.attr("data-confirmed") === "true";

  if (needsShade && !confirmed) {
    cmConfirmUpsellSelection($btn);
    cmUpdateUpsellStickyBar();
    return;
  }

  cmAddUpsellToCart($btn);
}

function cmResetUpsellCard($card) {
  $card.find("[data-upsell-swatch]").removeClass("active");

  var $btn = $card.find("[data-upsell-btn]");
  $btn.attr("data-confirmed", "false").removeClass("has-selection");
  $btn
    .find("[data-upsell-btn-label]")
    .text($btn.attr("data-needs-shade") === "true" ? "SELECT SHADE" : "ADD TO BAG");

  var $variantLabel = $card.find("[data-upsell-variant-label]");
  if ($variantLabel.length) {
    $variantLabel.text("Chosen color");
  }
}

function cmToggleUpsellCheck($check) {
  var $card = $check.closest("[data-upsell-card]");

  if ($card.hasClass("is-checked")) {
    $card.removeClass("is-checked");
    cmResetUpsellCard($card);
  } else {
    $card.addClass("is-checked");

    var $btn = $card.find("[data-upsell-btn]");
    if ($btn.attr("data-needs-shade") !== "true") {
      $btn.attr("data-confirmed", "true");
    }
  }

  cmUpdateUpsellStickyBar();
}

function cmGetReadyUpsellButtons() {
  return $(".mpm_upsell-list:not(.hided) [data-upsell-card].is-checked [data-upsell-btn]");
}

function cmUpdateUpsellStickyBar() {
  var $bar = $("[data-upsell-sticky-bar]");
  if (!$bar.length) return;

  var $readyBtns = cmGetReadyUpsellButtons();
  var count = $readyBtns.length;

  if (!count) {
    $bar.removeClass("is-visible");
    return;
  }

  var needsShadePending =
    $readyBtns.filter(function () {
      return $(this).attr("data-needs-shade") === "true" && $(this).attr("data-confirmed") !== "true";
    }).length > 0;

  if (needsShadePending) {
    $bar.find("[data-upsell-sticky-label]").text("SELECT SHADE");
    $bar.addClass("is-visible");
    return;
  }

  var totalCents = 0;
  $readyBtns.each(function () {
    totalCents += parseInt($(this).attr("data-price-cents"), 10) || 0;
  });

  var totalFormatted = (totalCents / 100).toFixed(2);
  var itemWord = count === 1 ? "ITEM" : "ITEMS";

  $bar
    .find("[data-upsell-sticky-label]")
    .text("ADD " + count + " " + itemWord + " · $" + totalFormatted);
  $bar.addClass("is-visible");
}

function cmAddAllUpsellItemsToCart() {
  var $bar = $("[data-upsell-sticky-bar]");
  var $readyBtns = cmGetReadyUpsellButtons();
  if (!$readyBtns.length) return;

  $bar.addClass("adding");

  var items = [];

  $readyBtns.each(function () {
    var $btn = $(this);
    var $card = $btn.closest("[data-upsell-card]");
    var dataRealBundle = $card.find(".mpm_real-bundle-config").attr("data-real-bundle");

    var saleOfferPercent = parseFloat($btn.attr("data-sale-discount")) || 0;
    var saleOfferActive =
      saleOfferPercent > 0 &&
      typeof getSaleCollectionVisitedCookie === "function" &&
      getSaleCollectionVisitedCookie() === "true";
    var saleOfferProperties = saleOfferActive ? { _SALEOFFER: saleOfferPercent + "%" } : {};
    var bfcmPercent = cmBfcmUpsellPercent($btn);
    if (bfcmPercent > 0) saleOfferProperties = { _BFCMOFFER: bfcmPercent + "%" };

    if (dataRealBundle === "true") {
      var bundleName = $btn.attr("data-bundle");
      $card.find(".mpm_real-bundle-config").each(function () {
        items.push({
          id: $(this).attr("data-id"),
          quantity: 1,
          properties: bfcmPercent > 0
            ? { Bundle: bundleName + " BFCM" }
            : Object.assign({ Bundle: bundleName }, saleOfferProperties),
        });
      });
    } else {
      items.push({
        id: $btn.attr("data-id"),
        quantity: 1,
        properties: saleOfferProperties,
      });
    }
  });

  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: { items: items },
    dataType: "json",
    success: function (data) {
      $bar.removeClass("adding");
      if (window.refreshCartDrawer) window.refreshCartDrawer(false, data.sections);
      if (window.openCartDrawer) window.openCartDrawer(true);
    },
    error: function () {
      $bar.removeClass("adding");
      if (window.refreshCartDrawer) window.refreshCartDrawer(false, null);
      if (window.openCartDrawer) window.openCartDrawer(true);
    },
  });
}

function cmInitUpsellCards() {
  $("[data-upsell-swatch]").on("click", function () {
    if ($(this).hasClass("is-unavailable")) return;
    cmSelectUpsellSwatch($(this));
  });

  $("[data-upsell-btn]").on("click", function () {
    cmHandleUpsellBtnClick($(this));
  });

  $("[data-upsell-card]").on("click", function (event) {
    var $target = $(event.target);
    if ($target.closest("[data-upsell-swatch]").length) return;
    if ($target.closest("[data-upsell-btn]").length) return;
    cmToggleUpsellCheck($(this));
  });

  $("[data-upsell-sticky-bar]").on("click", function () {
    cmAddAllUpsellItemsToCart();
  });

  $(".simple_upsell_outer .simple_upsell-switch").on("click", function () {
    setTimeout(cmUpdateUpsellStickyBar, 0);
  });
}

function cmScrollToPdp(event) {
  var $pdp = $(".ts-product__info");
  if (!$pdp.length) return;
  event.preventDefault();
  window.scrollTo({
    top: $pdp.offset().top - 100,
    behavior: "smooth",
  });
}

function cmInitWhyTheOneBtn() {
  $(".simple-why_btn").on("click", cmScrollToPdp);
}

function cmUpdateShimmerDots($carousel, $dots) {
  var el = $carousel[0];
  var $item = $carousel.find("[data-shimmer-item]").first();
  if (!$item.length || !$dots.length) return;

  var itemWidth = $item[0].getBoundingClientRect().width;
  var gap = parseFloat($carousel.css("gap")) || 0;
  var index = Math.round(el.scrollLeft / (itemWidth + gap)) % $dots.length;

  $dots.removeClass("active").eq(index).addClass("active");
}

function cmWrapShimmerCarousel($carousel) {
  var el = $carousel[0];
  var realWidth = el.scrollWidth / 3;

  if (el.scrollLeft <= 1) {
    el.scrollLeft += realWidth;
  } else if (el.scrollLeft >= realWidth * 2 - 1) {
    el.scrollLeft -= realWidth;
  }
}

function cmScrollShimmerCarousel($carousel, direction) {
  var el = $carousel[0];
  var $item = $carousel.find("[data-shimmer-item]").first();
  if (!$item.length) return;

  var itemWidth = $item[0].getBoundingClientRect().width;
  var gap = parseFloat($carousel.css("gap")) || 0;

  el.scrollBy({ left: direction * (itemWidth + gap), behavior: "smooth" });
}

function cmInitShimmerCarousel($carousel) {
  var $wrap = $carousel.closest(".simple-shimmer_carousel-wrap");
  var $prev = $wrap.find("[data-shimmer-prev]");
  var $next = $wrap.find("[data-shimmer-next]");
  var $dots = $wrap.closest(".simple-section_wrapper").find("[data-shimmer-dot]");
  var scrollTimer = null;
  var el = $carousel[0];

  el.scrollLeft = el.scrollWidth / 3;
  cmUpdateShimmerDots($carousel, $dots);

  $carousel.on("scroll", function () {
    cmUpdateShimmerDots($carousel, $dots);

    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(function () {
      cmWrapShimmerCarousel($carousel);
    }, 150);
  });

  $prev.on("click", function () {
    cmScrollShimmerCarousel($carousel, -1);
  });

  $next.on("click", function () {
    cmScrollShimmerCarousel($carousel, 1);
  });

  $dots.on("click", function () {
    var index = $dots.index(this);
    var $item = $carousel.find("[data-shimmer-item]:not([data-shimmer-clone])").eq(index);
    if (!$item.length) return;
    $carousel[0].scrollTo({ left: $item[0].offsetLeft, behavior: "smooth" });
  });
}

function cmInitAllShimmerCarousels() {
  $("[data-shimmer-carousel]").each(function () {
    cmInitShimmerCarousel($(this));
  });
}

function cmUpdateTestimonialDots($carousel, $dots) {
  var el = $carousel[0];
  var $slide = $carousel.find("[data-testimonial-slide]").first();
  if (!$slide.length || !$dots.length) return;

  var slideWidth = $slide[0].getBoundingClientRect().width;
  var index = Math.round(el.scrollLeft / slideWidth) % $dots.length;

  $dots.removeClass("active").eq(index).addClass("active");
}

function cmWrapTestimonialCarousel($carousel) {
  var el = $carousel[0];
  var realWidth = el.scrollWidth / 3;

  if (el.scrollLeft <= 1) {
    el.scrollLeft += realWidth;
  } else if (el.scrollLeft >= realWidth * 2 - 1) {
    el.scrollLeft -= realWidth;
  }
}

function cmInitTestimonialCarousel($carousel) {
  var $wrap = $carousel.closest(".simple-section_wrapper");
  var $dots = $wrap.find("[data-testimonial-dot]");
  var scrollTimer = null;
  var el = $carousel[0];

  el.scrollLeft = el.scrollWidth / 3;
  cmUpdateTestimonialDots($carousel, $dots);

  $carousel.on("scroll", function () {
    cmUpdateTestimonialDots($carousel, $dots);

    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(function () {
      cmWrapTestimonialCarousel($carousel);
    }, 150);
  });

  $dots.on("click", function () {
    var index = $dots.index(this);
    var $slide = $carousel.find("[data-testimonial-slide]:not([data-testimonial-clone])").eq(index);
    if (!$slide.length) return;
    el.scrollTo({ left: $slide[0].offsetLeft, behavior: "smooth" });
  });
}

function cmInitAllTestimonialCarousels() {
  $("[data-testimonial-carousel]").each(function () {
    cmInitTestimonialCarousel($(this));
  });
}

function cmStopAllUgcVideos() {
  $("[data-ugc-video-item]").each(function () {
    var $item = $(this);
    var video = $item.find("[data-ugc-video]")[0];
    if (video && !video.paused) {
      video.pause();
    }
    $item.removeClass("is-playing");
  });
}

function cmToggleUgcVideo($item) {
  var video = $item.find("[data-ugc-video]")[0];
  if (!video) return;

  if (video.paused) {
    cmStopAllUgcVideos();
    video.play();
    $item.addClass("is-playing");
  } else {
    video.pause();
    $item.removeClass("is-playing");
  }
}

function cmPrimeUgcVideoFrame(video) {
  var playPromise = video.play();
  if (playPromise !== undefined) {
    playPromise.catch(function () {});
  }
  setTimeout(function () {
    video.pause();
    video.currentTime = 0;
  }, 100);
}

function cmInitUgcVideos() {
  $("[data-ugc-video]").each(function () {
    cmPrimeUgcVideoFrame(this);
  });

  $("[data-ugc-video-item]").on("click", function (event) {
    event.stopPropagation();
    cmToggleUgcVideo($(this));
  });

  $(document).on("click", function () {
    cmStopAllUgcVideos();
  });
}

$(document).ready(function () {
  cmInitAllShadeEyeFilters();
  cmInitAllUgcCarousels();
  cmInitAccordion();
  cmInitUpsellCards();
  cmUpdateUpsellStickyBar();
  cmInitWhyTheOneBtn();
  cmInitAllShimmerCarousels();
  cmInitAllTestimonialCarousels();
  cmInitUgcVideos();
});
